import React from 'react';
import * as S from './AnalyticsReportLayout.styled';
export const AnalyticsReportLayout = ({ toolbar, children, aside, showAside = false, }) => {
    return (React.createElement(S.Container, null,
        toolbar,
        React.createElement(S.Inner, null,
            React.createElement(S.Content, { hasAside: !!aside && showAside }, children),
            aside && React.createElement(S.Aside, { visible: showAside }, aside))));
};
